// src/app/api/baseApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    // Since there's no refresh endpoint in the backend, just logout
    // If you implement token refresh later, add the logic here
    api.dispatch({ type: "auth/logout" });
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "User",
    "Product",
    "LeadMagnet",
    "SalesPage",
    "Investment",
    "Payment",
    "Member",
    "Portfolio",
    "Loan",
    "OfferSequence",
    "SequenceStats",
    "Payments",
    "PaymentAnalytics",
    "PaymentPages",
    "Contact",
    "ContactAnalytics",
    "EmailCampaign",
    "EmailCampaigns",
    "CampaignAnalytics",
    "Access",
    "Optin",
    "Subscription",
    "Site",
    "Course",
    "StudentCourse",
    "AdminStats",
    "AdminSubscribers",
    "AdminSubscriber",
    "AdminAnalytics",
    "AdminPayments",
    "Sms",
    "SmsHistory",
    "AdminSms",
    "Tenant",
    "Analytics",
    "Domain",
    "AdminDomains",
    "Ai",
    "AdminAi",
    "Usage",
    "Payout",
    "Withdrawals",
    "AdminPayouts",
    "AccountReviews",
    "Quiz",
    "FunnelMap",
    "Webinar",
    "WebinarRegistrations",
    "WebinarChatLog",
  ],
  endpoints: () => ({}),
});
